import { api, URLs } from '@/libs/api'
import type {
  ApiResponse,
  GlobalQualification,
  GlobalQualificationPayload,
  LocalQualification,
  LocalQualificationPayload,
  Qualification,
} from '@/libs/interfaces'
import { qualificationsApiMock } from '@/libs/mocks/handlers/qualifications'

const qualificationsApiReal = {
  upsertGlobalQualification: async (
    params: { orgID: string } & GlobalQualificationPayload,
  ): Promise<Partial<GlobalQualification>> => {
    const { orgID, quals } = params
    return await api
      .put<ApiResponse<Partial<GlobalQualification>>>(URLs.Qualifications.createGlobal(orgID), {
        quals,
      })
      .then((response) => response.data.data)
  },
  upsertLocalQualification: async (
    params: { storeID: string } & LocalQualificationPayload,
  ): Promise<Partial<LocalQualification>> => {
    const { storeID, quals } = params
    return await api
      .put<ApiResponse<Partial<LocalQualification>>>(URLs.Qualifications.createLocal(storeID), {
        quals,
      })
      .then((response) => response.data.data)
  },
  deleteGlobalQualification: async (
    params: Partial<GlobalQualification>,
  ): Promise<GlobalQualification> => {
    const { orgID } = params
    return await api
      .delete<ApiResponse<GlobalQualification>>(URLs.Qualifications.deleteGlobal(orgID || ''))
      .then((response) => response.data.data)
  },
  deleteLocalQualification: async (
    params: Partial<LocalQualification>,
  ): Promise<LocalQualification> => {
    const { storeID } = params
    return await api
      .delete<ApiResponse<LocalQualification>>(URLs.Qualifications.deleteLocal(storeID || ''))
      .then((response) => response.data.data)
  },
  list: async (orgID: string, query: string): Promise<Qualification> => {
    return await api
      .get<Qualification>(URLs.Qualifications.list(orgID, query))
      .then((response) => response.data)
  },
  getByIDGlobal: async (orgID: string, globalQualID: string): Promise<GlobalQualification> => {
    return await api
      .get<ApiResponse<GlobalQualification>>(URLs.Qualifications.byIDGlobal(orgID, globalQualID))
      .then((response) => response.data.data)
  },
  getByIDLocal: async (storeID: string, localQualID: string): Promise<LocalQualification> => {
    return await api
      .get<ApiResponse<LocalQualification>>(URLs.Qualifications.byIDLocal(storeID, localQualID))
      .then((response) => response.data.data)
  },
}

export const qualificationsApi: typeof qualificationsApiReal = __IS_MOCK_MODE__
  ? qualificationsApiMock
  : qualificationsApiReal
